export const reportPage_LABELS = {
  Intiated: "Initiated",
  InProgress: "InProgress",
  Generated: "Generated",
  Failed: "Failed",
  Expired: "Expired",
  NoData: "NoData",
  other: "Other",
};
